import useBreakpoints from "hooks/useBreakpoints";
import Box from "@mui/material/Box";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { Link } from "@mui/material";
import { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setOpen } from "redux/slices";
import { SiteLink } from "interfaces";
import { Title, CookieButton } from "./styles";
import { useLinks } from "hooks/useLinks";

const CookiesButton = () => {
	const text = "Cookies";

	return (
		<CookieButton
			id="uc-sdk-btn"
			className="uc-sdk-show-settings"
			onClick={() => window.UC_UI?.showSecondLayer()}
		>
			{text}
		</CookieButton>
	);
};

export const MenuLinks = () => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { isSmDown } = useBreakpoints();
	const dispatch = useDispatch();
	const links = useLinks();

	const reportToGoogle = (analytics_key: string) => {
		reportEvent(analytics_key, { source: "mega_menu" });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: analytics_key,
			event_type: "left_menu",
			action: analytics_key,
			source: "left_menu"
		});
	};

	const handleClick = (link: SiteLink) => {
		dispatch(setOpen(false));
		reportToGoogle(link.analytics_key);
	};

	const items = [links.tos, links.privacy];

	return (
		<Box
			sx={{
				display: "block",
				textAlign: "center",
				marginTop: "10px",
				marginBottom: "10px"
			}}
		>
			{items.map((item, index) => {
				if (item.isExternal) {
					return (
						<Fragment key={item.title}>
							<Link
								sx={{
									textDecoration: "none"
								}}
								href={item.path}
								title={item.title}
								target="_blank"
								onClick={() => reportToGoogle(item.analytics_key)}
							>
								<Title>{item.title}</Title>
							</Link>
							{isSmDown ? (
								!index ? (
									<span style={{ marginTop: "20px" }}>|</span>
								) : null
							) : (
								<span style={{ marginTop: "20px" }}>|</span>
							)}
						</Fragment>
					);
				}

				return (
					<Fragment key={item.title}>
						<RouterLink
							to={item.path}
							style={{
								textDecoration: "none"
							}}
							key={item.path}
							onClick={() => handleClick(item)}
						>
							<Title>{item.title}</Title>
						</RouterLink>
						{items[index + 1]?.title && (
							<span style={{ marginTop: "20px" }}>|</span>
						)}
					</Fragment>
				);
			})}

			<Fragment key="cookie">
				<CookiesButton />
			</Fragment>
		</Box>
	);
};
